import React from 'react';
import PropTypes from 'prop-types';
import EventEmitter from 'events';

import BaseModal from './BaseModal';
import GenResolveView from '../view/GenResolve/component/GenResolveView';

class GenResolveForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { transactionId, } = this.props;
    const events = new EventEmitter();
    return (
      <BaseModal title={`Gen Resolve ${transactionId}`} buttonLbl="Gen Resolve" events={events}>
        <GenResolveView transactionId={transactionId} events={events} />
      </BaseModal>
    );
  }
}

GenResolveForm.propTypes = {
  transactionId: PropTypes.string.isRequired,
};
export default GenResolveForm;
